import React from 'react';
import { useParams } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import LineChart from './LineChart.js';
import PieChart from './PieChart.js';

export default function CustomDashboard({ dashboard }) {
  const [data, setData] = React.useState();
  const { id } = useParams();

  React.useEffect(() => {
    const f = async () => {
      const response = await fetch(`/api/dashboards/${dashboard || id}`)
      const jsonData = await response.json();
      setData(jsonData);
    };
    f();
  }, [id, dashboard]);

  return (
    <>
      {data ?
        <>
          {data.map((report, i) => {
            return (
              <React.Fragment key={i}>
                {report.type === 'date' &&
                  <LineChart {...report.props} />
                }
                {report.type === 'bar' &&
                  <PieChart asBarChart="true" {...report.props} />
                }
              </React.Fragment>
            );
          })}
        </>
      :
        <Spinner animation="grow" role="status">
          <span className="sr-only">Loading...</span>
        </Spinner>
      }
      {/* <LineChart filters={{team: 'DevVoices'}} fixedMetric="page_views" fixedInterval="m" fixedStart="2020-01-01" fixedEnd="2021-09-20" title="Monthly Traffic by Language" /> */}
      {/* <LineChart filters={{team: 'DevVoices'}} fixedMetric="page_views" withSplits={true} fixedSplit="languages" fixedInterval="m" fixedStart="2020-01-01" fixedEnd="2021-09-20" title="Monthly Traffic by Language" /> */}
    </>
  );
};

